import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import ReportViewer from '../ReportViewer';
import ReportHeader from '../Utils/ReportHeader';
import ReportFooter from '../Utils/ReportFooter';
import ReportFilterInfo from '../Utils/ReportFilterInfo';
import { generalStyles } from '../Utils/ReportStyling';
import Breadcrumbs from '../../CustomControls/Breadcrumb';
import { getAllRptCompanyData, setOnSearchChange } from '../../../store/actions/ReportAdmin/rptCompany';
import Dropdown from '../../CustomControls/Dropdown';
import { CSVLink } from "react-csv";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { STATUSES } from '../../../constants/filterConstants';

import LoadingSpinner from '../../CustomControls/Spinner';

const styles = StyleSheet.create({
  maxReqQty: {
    width: '10%'
  },
  companyName: {
    width: '22%'
  },
  licenseKey: {
    width: '8%'
  },
  abn: {
    width: '10%'
  },
  taxName: {
    width: '8%'
  },
  tax: {
    width: '6%'
  },
  primaryContactPerson: {
    width: '14%'
  },
  primaryContactEmail: {
    width: '15%'
  },
  status: {
    width: '7%'
  }
});

const CompanyListingRpt = props => {
  const dispatch = useDispatch();
  const [filterStatus, setFilterStatus] = useState({ field: 'isactive', value: 'all', label: 'All' });
  const rptData = useSelector(state => state.rptCompanyListing);

  const isLoading = rptData.isLoading || false;
  const data = rptData.rptList;
  const filterData = rptData.filterData;
  const reportHeading = 'Company Listing';

  useEffect(() => {
    dispatch(getAllRptCompanyData(rptData.filterOptions.filterBy, rptData.filterOptions.sortBy, true));
  }, []);

  const breadCrumbPaths = [
    { id: 1, title: 'Home', path: '/' },
    { id: 2, title: `${reportHeading} Report`, path: '/admin-reports/company-listing', isCurrent: true }
  ];

  const dropdownChange = (field, selectionOption, callSetMethod) => {
    selectionOption.field = field;
    callSetMethod(selectionOption);
  };

  const setLocalChange = currentState => {
    dispatch(setOnSearchChange(currentState));
  };

  const onGenerateHandler = () => {
    let filterSearchList = rptData.filterOptions.filterBy || [];

    filterSearchList = getFilterData(filterSearchList, filterStatus);


    setLocalChange({
      ...rptData,
      data: { ...rptData.filterOptions, filterBy: filterSearchList }
    });

    dispatch(getAllRptCompanyData(rptData.filterOptions.filterBy, rptData.filterOptions.sortBy));
  };

  const getFilterData = (filterSearchList, filterObj) => {
    const objIndex = filterSearchList.findIndex(x => x.name.toLowerCase() === filterObj.field);
    if (objIndex !== -1) {
      filterSearchList[objIndex].value = filterObj.value;
      filterSearchList[objIndex].valueName = filterObj.label;
    } else {
      filterSearchList.push({ name: filterObj.field, value: filterObj.value, valueName: filterObj.label });
    }
    return filterSearchList;
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={`${reportHeading} Report`} paths={breadCrumbPaths} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <Row className="mb-2 buttonrow">
                    <Col sm="3">
                      <div className="mb-3">
                        <Dropdown
                          placeholder="Select Status"
                          label="Status"
                          name="isactive"
                          options={STATUSES}
                          isMulti={false}
                          value={STATUSES.find(x => x.value === filterStatus.value)}
                          onChange={val => dropdownChange('isactive', val, setFilterStatus)}
                          validate={{
                            required: { value: false }
                          }}
                        />
                      </div>
                    </Col>
                    <Col sm="7">
                      <div className="text-sm-start">
                        <Button type="button" className="btn btn-primary btn-block  app-add-button" onClick={onGenerateHandler}>
                          GENERATE
                        </Button>
                      </div>
                    </Col>
                    <Col sm="2">
                      <div className="text-sm-end">
                        <CSVLink
                          data={data}
                          headers={exportHeader}
                          filename={"companylisting.csv"}
                          className="btn btn-primary download-button"
                        >
                          <FontAwesomeIcon icon={faFileExcel} /> EXPORT
                        </CSVLink>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl="12">
                      {isLoading ? (
                        <LoadingSpinner />
                      ) : (
                        <ReportViewer>
                          <Document title={reportHeading}>
                            <Page style={generalStyles.body} orientation="landscape">
                              <ReportHeader reportTitle={reportHeading} />
                              <ReportFilterInfo filterList={rptData.filterOptions.filterBy} />
                              <View style={generalStyles.table}>
                                <View style={generalStyles.tableRow}>
                            
                                  <View style={[generalStyles.tableColHeader, styles.companyName]}>
                                    <Text style={generalStyles.tableCellHeader}>Company Name</Text>
                                  </View>
                                  
                                  <View style={[generalStyles.tableColHeader, styles.abn]}>
                                    <Text style={generalStyles.tableCellHeader}>ABN</Text>
                                  </View>
                                  <View style={[generalStyles.tableColHeader, styles.taxName]}>
                                    <Text style={generalStyles.tableCellHeader}>Tax Name</Text>
                                  </View>
                                  <View style={[generalStyles.tableColHeader, styles.tax]}>
                                    <Text style={generalStyles.tableCellHeader}>Tax</Text>
                                  </View>
                                  <View style={[generalStyles.tableColHeader, styles.maxReqQty]}>
                                    <Text style={generalStyles.tableCellHeader}>Max Req Qty</Text>
                                  </View>
                                  <View style={[generalStyles.tableColHeader, styles.primaryContactPerson]}>
                                    <Text style={generalStyles.tableCellHeader}>Contact Person</Text>
                                  </View>
                                  <View style={[generalStyles.tableColHeader, styles.primaryContactEmail]}>
                                    <Text style={generalStyles.tableCellHeader}>Contact Email</Text>
                                  </View>
                                  <View style={[generalStyles.tableColHeader, styles.licenseKey]}>
                                    <Text style={generalStyles.tableCellHeader}>Licensed</Text>
                                  </View>
                                  <View style={[generalStyles.tableColHeader, styles.status]}>
                                    <Text style={generalStyles.tableCellHeader}>Status</Text>
                                  </View>
                                </View>
                                {data.length > 0 && <ReportDataRow results={data} />}
                              </View>
                              <ReportFooter footerInfo={reportHeading}>
                                <Text
                                  style={generalStyles.pageNumber}
                                  render={({ pageNumber, totalPages }) => `Page ${pageNumber} of  ${totalPages}`}
                                />
                              </ReportFooter>
                            </Page>
                          </Document>
                        </ReportViewer>
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

const ReportDataRow = ({ results }) => {
  return (
    <View>
      {results.map(item => {
        return (
          <View style={generalStyles.tableRow} key={item.id}>
            <View style={[generalStyles.tableCol, styles.companyName]}>
              <Text style={generalStyles.tableCell}> {item.companyName} </Text>
            </View>
            <View style={[generalStyles.tableCol, styles.abn]}>
              <Text style={generalStyles.tableCell}>{item.abn}</Text>
            </View>
            <View style={[generalStyles.tableCol, styles.taxName]}>
              <Text style={generalStyles.tableCell}>{item.taxName}</Text>
            </View>
            <View style={[generalStyles.tableCol, styles.tax]}>
              <Text style={generalStyles.tableCell}>{item.tax}</Text>
            </View>
            <View style={[generalStyles.tableCol, styles.maxReqQty]}>
              <Text style={generalStyles.tableCell}>{item.maxReqQty}</Text>
            </View>
            <View style={[generalStyles.tableCol, styles.primaryContactPerson]}>
              <Text style={generalStyles.tableCell}>{item.primaryContactPerson}</Text>
            </View>
            <View style={[generalStyles.tableCol, styles.primaryContactEmail]}>
              <Text style={generalStyles.tableCell}>{item.primaryContactEmail}</Text>
            </View>
            <View style={[generalStyles.tableCol, styles.licenseKey]}>
              <Text style={generalStyles.tableCell}>{item.licenseKey}</Text>
            </View>
            <View style={[generalStyles.tableCol, styles.status]}>
              <Text style={generalStyles.tableCell}>{item.isActive}</Text>
            </View>
          </View>
        );
      })}
    </View>
  );
};

export default CompanyListingRpt;

const exportHeader = [
  { label: "Company Name", key: "companyName" },
  { label: "ABN", key: "abn" },
  { label: "Tax Name", key: "taxName" },
  { label: "Tax", key: "tax" },
  { label: "Max Req Qty", key: "maxReqQty" },
  { label: "Contact Person", key: "primaryContactPerson" },
  { label: "Contact Email", key: "primaryContactEmail" },
  { label: "Licensed", key: "licenseKey" },
  { label: "Status", key: "isActive" },
];